module.exports = __webpack_public_path__ + "media/images/common/ico-star-on-64a1a5ca927781faada363a3e19ea8d5.svg";